import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { api } from '.';
export function fetchActivities() {
  return _fetchActivities.apply(this, arguments);
}

function _fetchActivities() {
  _fetchActivities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref,
        _ref$offset,
        offset,
        _ref$limit,
        limit,
        activitiesList,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 1 : _ref$offset, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 1000 : _ref$limit;
            _context.prev = 1;
            _context.next = 4;
            return api.get("/quote_data/business_activities?offset=".concat(offset, "&limit=").concat(limit));

          case 4:
            activitiesList = _context.sent;
            return _context.abrupt("return", activitiesList.data.data);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _fetchActivities.apply(this, arguments);
}

export function fetchExtraActivities() {
  return _fetchExtraActivities.apply(this, arguments);
}

function _fetchExtraActivities() {
  _fetchExtraActivities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ref2,
        _ref2$offset,
        offset,
        _ref2$limit,
        limit,
        extraActivitiesList,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? 1 : _ref2$offset, _ref2$limit = _ref2.limit, limit = _ref2$limit === void 0 ? 1000 : _ref2$limit;
            _context2.prev = 1;
            _context2.next = 4;
            return api.get("/quote_data/business_works?offset=".concat(offset, "&limit=").concat(limit));

          case 4:
            extraActivitiesList = _context2.sent;
            return _context2.abrupt("return", extraActivitiesList.data.data);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", console.error(_context2.t0));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _fetchExtraActivities.apply(this, arguments);
}